export { default } from './ModalContentError'
export type { ModalContentErrorProps } from './ModalContentError'
